<avd-code-example-header
    [packageName]="packageName"
    [getStartedLink]="getStartedLink"
    [storybookLink]="storybookLink"
    [repoLink]="repoLink"
></avd-code-example-header>

@for (example of examples; track example.variant) {
    <avd-code-example
        [label]="example.label"
        [description]="example.description"
        [htmlSnippet]="example.htmlSnippet"
    >
        <uilab-mat-tab-group animationDuration="0ms">
            <uilab-mat-tab label="Overview">
                <p>Overview content</p>
            </uilab-mat-tab>
            <uilab-mat-tab label="Details">
                <p>Details content</p>
            </uilab-mat-tab>
            <uilab-mat-tab label="Usage">
                <p>Usage content</p>
            </uilab-mat-tab>
            <uilab-mat-tab label="API">
                <p>API content</p>
            </uilab-mat-tab>
            <uilab-mat-tab label="Examples">
                <p>Examples content</p>
            </uilab-mat-tab>
        </uilab-mat-tab-group>
    </avd-code-example>
}
